/**
 * Terms & Conditions Page
 *
 * Task: T4.3.4 - Policy pages
 */

import {
  Page,
  Layout,
  Card,
  Text,
  BlockStack,
  Box,
} from '@shopify/polaris';

export function TermsPage() {
  return (
    <Page title="Terms & Conditions" narrowWidth>
      <Layout>
        <Layout.Section>
          <Card>
            <Box padding="600">
              <BlockStack gap="600">
                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    1. General
                  </Text>
                  <Text as="p" variant="bodyMd">
                    These terms and conditions govern your use of <strong>GiftSangam.com</strong> and
                    the purchase of products from <strong>Novadhara Ventures</strong>. By accessing
                    this website, you agree to these terms.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    2. Customization & Orders
                  </Text>
                  <Text as="p" variant="bodyMd">
                    <strong>Approval:</strong> All custom orders (logo printing, engraving, etc.)
                    require written approval of the digital mock-up/artwork by the client before
                    production begins.
                  </Text>
                  <Text as="p" variant="bodyMd">
                    <strong>Variations:</strong> Slight variations in color or texture may occur
                    due to the nature of materials (e.g., leather, wood) and manufacturing processes.
                    These are not considered defects.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    3. Returns & Refunds
                  </Text>
                  <Text as="p" variant="bodyMd">
                    <strong>Custom Goods:</strong> Due to the personalized nature of corporate gifts,
                    we do not accept returns or refunds on customized items once the artwork is approved
                    and production has started, unless there is a manufacturing defect.
                  </Text>
                  <Text as="p" variant="bodyMd">
                    <strong>Defects:</strong> Any defects must be reported within <strong>48 hours</strong> of
                    delivery with photographic evidence.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    4. Payments
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Unless otherwise agreed in writing, a <strong>50% advance payment</strong> is
                    required to confirm an order, with the balance due prior to dispatch.
                  </Text>
                </BlockStack>
              </BlockStack>
            </Box>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
